import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withKeys as _withKeys, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-66f14544"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modal-background" }, null, -1))
const _hoisted_2 = {
  key: 0,
  class: "modal-card"
}
const _hoisted_3 = { class: "modal-card-head" }
const _hoisted_4 = { class: "modal-card-title is-title-shrink" }
const _hoisted_5 = { class: "modal-card-body" }
const _hoisted_6 = { class: "modal-card-foot custom-modal-card-foot is-justify-content-flex-end" }
const _hoisted_7 = ["disabled"]
const _hoisted_8 = {
  key: 1,
  class: "modal-card"
}
const _hoisted_9 = { class: "modal-card-head" }
const _hoisted_10 = { class: "is-flex is-flex-shrink-0" }
const _hoisted_11 = { class: "icon has-text-white" }
const _hoisted_12 = { class: "modal-card-title is-title-shrink" }
const _hoisted_13 = { class: "icon" }
const _hoisted_14 = { class: "modal-card-body" }
const _hoisted_15 = {
  class: "qrcode-container",
  ref: "qrCodeTransaction"
}
const _hoisted_16 = { class: "has-text-centered is-size-4 mt-2" }
const _hoisted_17 = { class: "modal-card-foot custom-modal-card-foot is-justify-content-flex-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MoneyTransaction = _resolveComponent("MoneyTransaction")!
  const _component_fa_icon = _resolveComponent("fa-icon")!
  const _component_QrCodeVue = _resolveComponent("QrCodeVue")!

  return (_openBlock(), _createElementBlock("div", {
    class: "modal is-active",
    tabindex: "0",
    onKeyup: _cache[10] || (_cache[10] = _withKeys(($event: any) => (_ctx.isValid ? _ctx.$modal.next() : null), ["enter"]))
  }, [
    _hoisted_1,
    (_ctx.$modal.step.value == 1)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("header", _hoisted_3, [
            _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.$gettext("Request money")) + " - 1/2 ", 1),
            _createElementVNode("button", {
              class: "delete",
              "aria-label": "close",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.close()))
            })
          ]),
          _createElementVNode("section", _hoisted_5, [
            _createVNode(_component_MoneyTransaction, {
              directionTransfer: "receive",
              account: _ctx.$modal.args.value[0].account,
              selectedRecipient: _ctx.selectedRecipient,
              config: _ctx.config,
              transactionType: "createRequestPay",
              "onUpdate:amount": _cache[1] || (_cache[1] = (x) => (_ctx.amount = x)),
              "onUpdate:senderMemo": _cache[2] || (_cache[2] = (x) => (_ctx.senderMemo = x)),
              "onUpdate:recipientMemo": _cache[3] || (_cache[3] = (x) => (_ctx.recipientMemo = x)),
              "onUpdate:isValid": _cache[4] || (_cache[4] = (x) => (_ctx.isValid = x))
            }, null, 8, ["account", "selectedRecipient", "config"])
          ]),
          _createElementVNode("footer", _hoisted_6, [
            _createElementVNode("button", {
              disabled: !_ctx.isValid,
              class: "button custom-button-modal has-text-weight-medium",
              id: "send-money-button",
              onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$modal.next()))
            }, _toDisplayString(_ctx.$gettext("Generate QR code")), 9, _hoisted_7)
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.$modal.step.value == 2)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _createElementVNode("header", _hoisted_9, [
            _createElementVNode("span", _hoisted_10, [
              _createElementVNode("a", {
                class: "mr-3 is-flex",
                onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.$modal.back()))
              }, [
                _createElementVNode("span", _hoisted_11, [
                  _createVNode(_component_fa_icon, {
                    icon: "arrow-left",
                    class: "fa-lg"
                  })
                ])
              ])
            ]),
            _createElementVNode("p", _hoisted_12, _toDisplayString(_ctx.$gettext("Request money")) + " - 2/2 ", 1),
            (_ctx.$platform === 'web')
              ? (_openBlock(), _createElementBlock("span", {
                  key: 0,
                  onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.downloadQrCodePdf && _ctx.downloadQrCodePdf(...args))),
                  class: "button download is-default is-rounded refresh mr-2 ml-2"
                }, [
                  _createElementVNode("span", _hoisted_13, [
                    _createVNode(_component_fa_icon, { icon: "download" })
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("button", {
              class: "delete",
              "aria-label": "close",
              onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.close()))
            })
          ]),
          _createElementVNode("section", _hoisted_14, [
            _createElementVNode("div", _hoisted_15, [
              _createVNode(_component_QrCodeVue, {
                "render-as": "svg",
                size: 200,
                value: 
                JSON.stringify({
                  rp: _ctx.userProfile.id,
                  rpb: _ctx.$modal.args.value[0].account.id,
                  amount: _ctx.amount,
                  senderMemo: _ctx.senderMemo,
                  recipientMemo: _ctx.recipientMemo,
                })
              
              }, null, 8, ["value"])
            ], 512),
            _createElementVNode("p", _hoisted_16, _toDisplayString(_ctx.$gettext("Please scan the QR code above to proceed")), 1)
          ]),
          _createElementVNode("footer", _hoisted_17, [
            _createElementVNode("button", {
              class: "button custom-button-modal has-text-weight-medium",
              id: "send-money-button",
              onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.$modal.close()))
            }, _toDisplayString(_ctx.$gettext("Close")), 1)
          ])
        ]))
      : _createCommentVNode("", true)
  ], 32))
}